import { render, staticRenderFns } from "./FooterNSG.vue?vue&type=template&id=70d6e7c5&scoped=true"
import script from "./FooterNSG.vue?vue&type=script&lang=js"
export * from "./FooterNSG.vue?vue&type=script&lang=js"
import style0 from "./FooterNSG.vue?vue&type=style&index=0&id=70d6e7c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d6e7c5",
  null
  
)

export default component.exports